export default __webpack_public_path__ + "static/media/AnimalsOrange_07.13c156db.png";